import {
  AxiosError,
  AxiosInstance,
  InternalAxiosRequestConfig,
  AxiosResponse,
} from "axios";
import SecurityService from "../services/Security";
import TokenService from "../services/Token";
import { onResponseError } from "./responseErrorInterceptor";
import InsightService from "./../services/Insight/index";

const onRequest = async (
  config: InternalAxiosRequestConfig
): Promise<InternalAxiosRequestConfig> => {
  const queryString = window.location.search;

  const urlParams = new URLSearchParams(queryString);
  let token;
  let authenticationToken;
  if (urlParams.get("token")) {
    TokenService.clearToken();
    token = urlParams.get("token");
    if (token) TokenService.setToken(token);
  } else if (urlParams.get("authetication_token")) {
    TokenService.clearToken();
    authenticationToken = urlParams.get("authetication_token");
    if (authenticationToken) {
      const accessToken = await handleAuthenticationToken(authenticationToken);
      if (accessToken) {
        TokenService.setToken(accessToken);
        token = accessToken;
      }
    }
  } else {
    token = TokenService.getToken();
  }
  const accessToken = token;

  if (config.headers && !config.headers.Authorization) {
    config.headers.Authorization = `Bearer ${accessToken}`;
    return config;
  }

  return config;
};

const handleAuthenticationToken = async (
  authToken: any,
): Promise<string | undefined> => {
  let encodedToken = encodeURIComponent(authToken);
  encodedToken = encodedToken?.replace(new RegExp("%20", "g"), "%2B");
  const decodedToken = decodeURIComponent(encodedToken);
  let result = "";
  try {
    await SecurityService.authenticate(decodedToken).then((response) => {
      result = response.access_token;
      return result;
    });
  } catch {
    return result;
  }
  return result;
};
const onRequestError = (error: AxiosError): Promise<AxiosError> => {
  return Promise.reject(error);
};

const onResponse = (response: AxiosResponse): AxiosResponse => {
  InsightService.logEvent("Request", [
    {
      request: {
        requestURL: response.request?.responseURL,
        config: response.config,
      },
    },
    { response: response.data },
  ]);
  return response.data.data;
};

export function setupInterceptorsTo(
  axiosInstance: AxiosInstance,
): AxiosInstance {
  axiosInstance.interceptors.request.use(onRequest, onRequestError);
  axiosInstance.interceptors.response.use(onResponse, onResponseError);
  return axiosInstance;
}
